import React from 'react'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { GameInfoCard, PopupMessageCard, PlayerBox } from '../containers'
import { TitleGrid, RenjuBoardCard } from '../../../containers'
import { getBreakpointsEnable } from '../../../lib'
import { boardType, PLAYER_TYPE, roomStatus } from '../../../constants';
import { isNumber } from 'util';
import { useEffect } from 'react'
import { useContext } from 'react'
import { SoundContext, SOUND_EFFECT_TYPE } from '../../../Parts/Sound/SoundProvider'
import { useRef } from 'react'
import { useState } from 'react'
import { GameContext } from '../GameProvider'
import { useDispatch } from 'react-redux'
import { types } from '../../../constants/ActionTypes'

const styles = theme => ({
})

function GameRoomRoot(props) {
  const { group: groupName, room: roomName } = props.match.params
  const gameContext = useContext(GameContext)

  useEffect(() => {
    if (gameContext.socket) {
      gameContext.joinGroup(groupName)
      gameContext.joinRoom(groupName, roomName)
    }
    return () => {
      gameContext.leaveRoom(groupName, roomName)
      gameContext.clearChat(groupName, roomName)
      gameContext.clearRoom()
    }
  }, [gameContext.socket])

  return (
    <GameRoom {...props}/>
  )
}

const GameRoom = (props) => {
  var bid, card, beforeRenjuBoardContent, afterRenjuBoardContent, popupMessageContent, player1, player2, disableLeftClick, isVisibleRenjuBoardHeaderContent, isVisibleOpeningRuleControlBox

  const { theme, width, userSettings, cards, roomName, groupName } = props
  const { md } = getBreakpointsEnable(theme, width)

  const soundContext = useContext(SoundContext)
  const gameContext = useContext(GameContext)
  const { room } = gameContext

  const [isMounted, setIsMounted] = useState(false)
  const [timer, setTimer] = useState()

  const prevRoom = useRef(room)

  const dispatch = useDispatch()

  bid = cards.findIndex(cd => {
    return (
      cd.type === boardType.GAME_ROOM &&
      cd.groupName === groupName && cd.roomName === roomName
    )
  })
  if (bid >= 0) {
    card = cards[bid]
  }

  useEffect(() => {
    if (!isMounted) {
      gameContext.setUrlGroupName(groupName)
      gameContext.setUrlRoomName(roomName)
      dispatch({ type: types.game.INITIALIZE, groupName, roomName })
    }
  }, [isMounted])

  useEffect(() => {
    if (!isMounted && room !== undefined ) {
      setIsMounted(true)
      let userAgent = window.navigator.userAgent.toLowerCase()
      if ( userAgent.indexOf('iphone') > 0 || userAgent.indexOf('ipad') > 0) {
        setTimer(setTimeout(() => {
          soundContext.firstOpen()
        }, 1000))
      }
    }
    if (
      prevRoom.current !== undefined && room !== undefined &&
      (
        (prevRoom.current.player1 === undefined && room.player1 !== undefined) ||
        (prevRoom.current.player2 === undefined && room.player2 !== undefined)
      )
    ) {
      soundContext.play(SOUND_EFFECT_TYPE.ENTER)
    }
    if (
      prevRoom.current !== undefined && room !== undefined &&
      prevRoom.current.moves !== undefined && room.moves !== undefined &&
      prevRoom.current.moves.length < room.moves.length &&
      room.moves.every(mv => mv.datetime !== undefined) &&
      isNumber(room.moves[room.moves.length -1].x) &&
      isNumber(room.moves[room.moves.length -1].y)
    ) {
      soundContext.play(SOUND_EFFECT_TYPE.PUT_PIECE)
    }
    if (
      prevRoom.current !== undefined && room !== undefined &&
      prevRoom.current.moves !== undefined && room.moves !== undefined &&
      prevRoom.current.moves.length < room.moves.length &&
      room.moves.every(mv => mv.datetime !== undefined) &&
      room.moves[room.moves.length -1].swap === true
    ) {
      soundContext.play(SOUND_EFFECT_TYPE.SWAP)
    }
    prevRoom.current = room

    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [room])

  if (room !== undefined && room.player2 !== undefined && userSettings !== undefined && room.player2.userName === userSettings.userName) {
    player1 = PLAYER_TYPE.PLAYER_2
    player2 = PLAYER_TYPE.PLAYER_1
  }
  else {
    player1 = room !== undefined && room.player1 !== undefined ? PLAYER_TYPE.PLAYER_1 : undefined
    player2 = room !== undefined && room.player2 !== undefined ? PLAYER_TYPE.PLAYER_2 : undefined
  }
  isVisibleRenjuBoardHeaderContent = Boolean(room !== undefined && room.status === roomStatus.PLAYING)
  afterRenjuBoardContent  = room !== undefined && md === false ?
    (<PlayerBox type={player1}/>) : undefined
  beforeRenjuBoardContent = room !== undefined && md === false ?
    (<PlayerBox type={player2}/>) : undefined
  popupMessageContent = room !== undefined ?
    (<PopupMessageCard {...{userSettings, room }}/>) : undefined
  if (room !== undefined) {
    switch (room.status) {
      case roomStatus.EMPTY:
      case roomStatus.WAIT:
        disableLeftClick = true
        break
      case roomStatus.PLAYING:
        disableLeftClick = Boolean(
          (card !== undefined && card.moves[card.moves.length - 1].datetime === undefined) ||
          room.turn === undefined || room.turn.userName === undefined ||
          userSettings === undefined || userSettings.userName === undefined ||
          room.turn.userName !== userSettings.userName
        )
        isVisibleOpeningRuleControlBox = !disableLeftClick
        break
      case roomStatus.END:
        disableLeftClick = true
        break
      default:
        break
    }
  }

  return (
    <TitleGrid>
      <Grid item xs={12} md={7}>
        {bid >= 0 && room !== undefined && (
          <RenjuBoardCard
            isVisibleCardHeader={false}
            isVisibleRenjuBoardHeaderContent={isVisibleRenjuBoardHeaderContent}
            isVisibleControlButtonsActions={false}
            isVisibleOpeningRuleBox={true}
            disableRightClick={true}
            disableLeftClick={disableLeftClick}
            {...{ bid, beforeRenjuBoardContent, afterRenjuBoardContent, popupMessageContent }}
            onChangeMove={(next, before) => {
              var move
              move = next.moves[next.moves.length - 1]
              if (move.player === undefined && move.datetime === undefined) {
                gameContext.move(groupName, roomName, next.moves)
              }
            }}
          />
        )}
      </Grid>
      <Grid item xs={12} md={5}>
        <GameInfoCard
          {...{ groupName, roomName, bid, isVisibleOpeningRuleControlBox, isVisibleControlButtons: false }}
          disabledPlayerBox={Boolean(md === false)}
        />
      </Grid>
    </TitleGrid>
  )
}

export default withStyles(styles, { withTheme: true })(GameRoomRoot)



// WEBPACK FOOTER //
// ./src/Pages/Game/components/GameRoom.js